import MuiIcon from 'components/Icons/MuiIcon/MuiIcon';
import { useAuthContext } from 'components/Login/hooks';
import NotificationBubble from 'components/NotificationBubble/NotificationBubble';
import { useHelpscoutPersonalProfile } from 'customer/components/help/Helpscout/hooks';

const HelpscoutNotificationsButton = () => {
  const { data: authContext } = useAuthContext();
  const { data: helpscoutPersonalProfile = {} } = useHelpscoutPersonalProfile(
    authContext?.userId,
  );

  return (
    <div style={{ position: 'relative' }}>
      <MuiIcon
        onClick={() => {
          window.Beacon('open', {});

          if (helpscoutPersonalProfile?.openConversations) {
            window.Beacon('navigate', '/previous-messages/');
          }
        }}
        icon="notifications_none"
        style={{ cursor: 'pointer' }}
      />
      {!!helpscoutPersonalProfile.adminInitiated && (
        <NotificationBubble
          count={helpscoutPersonalProfile.adminInitiated}
          danger
        />
      )}
    </div>
  );
};

export default HelpscoutNotificationsButton;
